<template>
  <!-- 底部弹出商品规格 -->
  <van-popup z-index="1000" closeable v-model:show="showBottom" id="Commodityspecification" position="bottom">
    <!-- 商品标题 -->
    <div class="shoptitle">
      <div class="img-box">
        <van-image lazy-load :src="detailsImg">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
      </div>

      <div class="text-box">
        <p class="top-title">{{ goodsInfo.title ? goodsInfo.title : goodsInfo.goods_title }}</p>
        <!-- <p class="price">
          <span class="dollar">
            ${{
              $fun.EURNumSegmentation(
                $fun.ceil(
                  goodsInfo.Unitprice * $store.state.exchangeRate
                )
              )
            }}

          </span>
          <span class="RMB">
            ￥{{ $fun.RMBNumSegmentation(goodsInfo.Unitprice) }}
          </span>

        </p> -->
        <p class="miaoshu"> <span>{{ $fanyi('已选') }}:</span>{{ text }}</p>
      </div>
    </div>
    <!-- 商品规格 -->
    <div> <!-- 循环每一项 -->
      <div class="Specifications">

        <div class="Specificationsitem" v-for="(key, value) in goodsInfo.specification" :key='key'>
          <div class="left-title">{{ RemoveDoublequotationmarks(value) }}</div>

          <div class="listitem">
            <div class="item" @click="getcolor(value, ind, item)" :class="{ itemcolor: item.check }"
              v-for="(item, ind ) in key" :key="ind">
              <van-image v-if="item.picUrl" lazy-load :src="item.picUrl">
                <template v-slot:loading>
                  <van-loading type="spinner" size="20" />
                </template>
              </van-image>
              <span class="Description">{{ item.name }}</span>


            </div>
          </div>

        </div>


      </div>
    </div>

    <!--  确认修改 -->
    <div class="confirm-box">
      <div class="confirm" @click="confirm">{{ $fanyi('确认') }}</div>
    </div>



  </van-popup>
</template>
<script setup>
import { getCurrentInstance, ref, defineExpose, defineEmits } from 'vue'
import { showLoadingToast, closeToast, showFailToast, showSuccessToast, showToast } from 'vant'
// showToast, showSuccessToast showFailToast,
const { proxy } = getCurrentInstance()
const showBottom = ref(false)// 控制弹窗显示
const goodsInfo = ref({})
const detailsImg = ref('')// 默认图片
const str = ref('')// 选中的sku
const text = ref('')// 展示的sku
const skuId = ref('')// 选中的skuid
const specId = ref('')// 选中的speId
const goodsnum = ref(0) //商品数量
const cartId = ref('')// 购物车id
const ordertype = ref('')// 父组件类型 cart 购物车使用， 其他页面使用数据需要转化
const open = async (goods, type) => {
  console.log(type);
  console.log(goods);
  ordertype.value = type
  // type 如果是cart 就是购物车 
  if (type == 'cart') {
    showLoadingToast({
      duration: 0,
      message: proxy.$fanyi("加载中..."),
      forbidClick: true,
      loadingType: "spinner",
    });
    const res = await proxy.$api.goodsCartAttribute({
      goods_id: goods.goods_id
    })
    closeToast()
    if (res.code != 0) {
      showFailToast(proxy.$fanyi(res.msg))
      return
    }

    goodsInfo.value = res.data

    // 
    for (let key in goodsInfo.value.specification) {
      // console.log( details.value ?.goodsInfo?.specification[key]);
      goodsInfo.value.specification[key].forEach((item) => {
        if (item.check == true) {

          if (item.picUrl) {
            detailsImg.value = item.picUrl
          } else {
            detailsImg.value = goodsInfo.value.pic
          }
        }
        else {
          item.check = false
        }
      })
    }


  } else {
    goodsInfo.value = goods
    // 数组格式不一样需要转化
    console.log(goodsInfo);
    for (let key in goodsInfo.value.specification) {
      goodsInfo.value.detail.forEach((i) => {
        goodsInfo.value.specification[key].forEach((item) => {

          if (i.value == item.name) {

            item.check = true
            console.log(item.check);
          }
          if (item.check == true) {

            if (item.picUrl) {
              detailsImg.value = item.picUrl
            } else {
              detailsImg.value = goodsInfo.value.pic
            }
          }

        })
      })

    }
  }
  console.log(goodsInfo.value);

  cartId.value = goods.cart_id  // 购物车id
  goodsnum.value = goods.num // 购物车数量
  showBottom.value = true
  Processingdata(goodsnum.value)
}


// 去除上双引号
const RemoveDoublequotationmarks = (value) => {
  value = value.replace(/^"|"$/g, '')
  return value
}
const getcolor = (key, index, item) => {

  if (item.picUrl) {
    detailsImg.value = item.picUrl
  }

  // 循环对象每一项对比，如果一致修改checed
  for (let itemkey in goodsInfo.value.specification) {

    if (key == itemkey) {

      goodsInfo.value.specification[key].forEach((item, ind) => {
        if (ind == index) {
          item.check = true
        }
        else {
          item.check = false
        }
      })
    }


  }
  Processingdata()

}
// 处理数据
const Processingdata = () => {
  // 清空数据
  str.value = ''
  text.value = ''

  for (let key in goodsInfo.value.specification) {
    goodsInfo.value.specification[key].forEach((item,) => {
      if (item.check == true) {
        str.value += item.name !== '' ? item.name + '㊖㊎' : ''
        text.value += RemoveDoublequotationmarks(key) + ':' + ' ' + item.name + ' '

      }
    })
  }
  // 去掉最后两个彩金
  str.value = str.value.substr(0, str.value.length - 2)

  if (ordertype.value == 'cart') {

    goodsInfo.value.goodsInventory?.forEach((item) => {

      if (str.value == item.keyC) {
        item.valueC.forEach((i) => {
          if (i.check == true)
            //  选中的单价
            goodsInfo.value.Unitprice = i.price

          //skuid
          skuId.value = i.skuId
          // specid
          specId.value = i.specId
        })
      }
    })
  }
  else {

    goodsInfo.value.goods_inventory?.forEach((item) => {

      if (str.value == item.keyC) {
        item.valueC.forEach((i) => {
          if (i.check == true)
            //  选中的单价
            goodsInfo.value.Unitprice = i.price

          //skuid
          skuId.value = i.skuId
          // specid
          specId.value = i.specId
        })
      }
    })

  }




}
const emit = defineEmits(['renewdata'])
// 确认修改
const confirm = async () => {

  let chineseArr = [] // 中文规格key
  let englishArr = [] // 英文
  let detailChinese = []// 选中的中文 skuArr
  let detailenglish = []// 英文的sku
  var index = 0
  if (goodsInfo.value.goodsInventory) {
    index = goodsInfo.value.goodsInventory.findIndex((item) => str.value == item.keyC)
  } else {
    index = goodsInfo.value.goods_inventory.findIndex((item) => str.value == item.keyC)
  }
  if (index == -1) {
    showToast(proxy.$fanyi('此规格商品暂无库存'))
    return
  }
  // 中文
  for (let key in JSON.parse(JSON.stringify(goodsInfo.value.specificationChinese))) {

    chineseArr.push(key)
  }
  // 英文
  for (let key in JSON.parse(JSON.stringify(goodsInfo.value.specification))) {

    englishArr.push(key)
  }
  if (ordertype.value == 'cart') {
    chineseArr.forEach((i, ind) => {
      detailChinese.push({
        key: i,
        value: goodsInfo.value.goodsInventoryChinese[index].keyC.split('㊖㊎')[ind],
      })
    })
    let data = {
      cart_id: cartId.value,
      attribute: detailChinese,
      sku_id: skuId.value,
      pic: detailsImg.value

    }


    const res = await proxy.$api.cartAttributeEdit(data)
    if (res.code != 0) {
      showFailToast(res.msg)
      return
    }

    showSuccessToast(proxy.$fanyi('修改成功'))
  } else {
    // 中文

    chineseArr.forEach((i, ind) => {
      detailChinese.push({
        key: i.replace(/\\/g, ""),
        value: goodsInfo.value.goods_inventoryChinese[index].keyC.split('㊖㊎')[ind],
      })
    })
    // 英文
    englishArr.forEach((i, ind) => {
      detailenglish.push({
        key: i.replace(/\\/g, ""),
        value: goodsInfo.value.goods_inventory[index].keyC.split('㊖㊎')[ind],
      })
    })


  }


  console.log(detailChinese, detailenglish);

  showBottom.value = false


  console.log(detailsImg);
  emit('renewdata', goodsInfo.value, {
    key: detailChinese,
    value: detailenglish
  }, detailsImg.value)
  goodsInfo.value = []
}




defineExpose({
  open
})
</script>
<style lang="scss">
#Commodityspecification {
  width: 375px;
  min-height: 250px;
  background: #FFFFFF;
  border-radius: 8px 8px 0px 0px;
  max-height: 80%;
  padding-top: 20px;




}
</style>
<style lang='scss' scoped='scoped'>
@import "@/style/scss/mixin.scss";

.shoptitle {
  width: 100%;
  padding: 0 20px;
  min-height: 60px;
  font-size: 14px;
  font-family: ArialMT;
  color: #222222;
  line-height: 20px;
  margin-bottom: 30px;
  height: 40px;
  font-size: 14px;
  font-family: ArialMT;
  color: #222222;
  line-height: 20px;
  display: flex;


  :deep().van-image {
    width: 60px;
    height: 60px;
  }

  .img-box {
    width: 60px;
    height: 60px;
  }

  :deep().van-image__img {
    width: 60px;
    height: 60px;
  }

  :deep().van-image__loading {
    width: 60px;
    height: 60px;
  }

}




:deep().van-icon-cross {
  color: #333;
  font-weight: 500;
}



// 规格
.Specifications {

  width: 100%;


  .Specificationsitem {
    height: 40px;
    margin-bottom: 30px;
    padding-left: 20px;
    display: flex;
    overflow-x: scroll;
    // overflow-y: hidden;
    white-space: nowrap;

    .left-title {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      font-size: 12px;
      font-family: ArialMT;
      color: #666666;
      line-height: 18px;
      margin-right: 22px;
    }

    .listitem {
      display: flex;
      overflow-x: scroll;
      // overflow-y: hidden;
      white-space: nowrap;
      border-radius: 4px;

      .item {
        height: 40px;

        padding: 0 10px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 0.5px solid #E2E2E2;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;



        :deep().van-image {
          width: 30px;
          height: 30px;
          margin-right: 10px;
        }


        .Description {

          font-size: 12px;
          font-family: ArialMT;
          color: #666666;
          line-height: 18px;
        }

      }

      .itemcolor {
        border: 1px solid #FF730B;

        .Description {
          color: #FF730B !important;
        }

      }

    }

  }


}

.text-box {
  height: 100%;
  margin-left: 10px;


  // .price {
  //   height: 20px;
  //   font-size: 14px;
  //   font-size: 14px;
  //   font-family: Arial-BoldMT, Arial;
  //   font-weight: 600;
  //   color: #FF730B;
  //   line-height: 20px;

  //   margin-bottom: 5px;

  //   span {
  //     height: 20px;
  //     font-size: 14px;
  //     font-family: Arial-BoldMT, Arial;
  //     font-weight: 600;
  //     color: #FF730B;
  //     line-height: 20px;
  //   }

  // }

  .top-title {
    height: 32px;
    font-size: 12px;
    font-family: ArialMT;
    color: #222222;
    line-height: 16px;
    width: 238px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin-bottom: 13px;
  }

  .miaoshu {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 10px;
    padding: 0px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 16px;
    margin: 0;

    span {
      margin-right: 5px;
    }

  }

}

.confirm-box {
  width: 100%;
  padding: 0 20px;
  box-shadow: inset 0px 0.5px 0px 0px #E2E2E2;
  padding-top: 10px;
  margin-bottom: 30px;
}

.confirm {
  width: 335px;
  height: 48px;
  background: #FF730B;
  border-radius: 6px;
  margin: auto;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>